module.exports = __webpack_public_path__ + "img/send_arrow.35aff041.svg";